import { pdf } from '@react-pdf/renderer';
import { generateQrDataUrl } from './qrCode';
import SlipDocument from './SlipDocument';
import { getUnit } from '../utils';

// booking should already have private fields (phone/nicNo/serialNo) merged
// back in — e.g. via AdminPanel's withPrivateData() — otherwise those fields
// just render blank on the slip.
export async function generateSlipPdf(booking, { cancelled = false, paidStamp = false } = {}) {
  const qrDataUrl = booking.serialNo ? await generateQrDataUrl(booking.serialNo) : null;
  const unitLabel = getUnit(booking) === 'silver' ? 'Silver' : 'Gold';

  const blob = await pdf(
    <SlipDocument
      booking={booking}
      qrDataUrl={qrDataUrl}
      logoDataUrl="/apple-touch-icon.png"
      signatureDataUrl="/riazfarmhouse_signature.png"
      tickDataUrl="/black_thick_mark.png"
      cancelledDataUrl={cancelled ? '/cancelled.png' : null}
      paidStampDataUrl={paidStamp ? '/fullypaid.png' : null}
      unitLabel={unitLabel}
    />
  ).toBlob();

  return blob;
}
